import tokenActions from './tokenActions';

const allActions = {
  tokenActions
};

export default allActions;
